import { Outlet } from "react-router-dom";

export default function AuthRoot() {
    return (
        <div id="auth-root">
            <Outlet />
        </div>
    );
}